module.exports = __webpack_public_path__ + "static/img/gd-08.6b7dca9e.jpg";